import { render } from "./TableIndexForm.vue?vue&type=template&id=756c03f4"
import script from "./TableIndexForm.vue?vue&type=script&lang=js"
export * from "./TableIndexForm.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__